import parse from 'html-react-parser';
import type React from 'react';
import type { TextData } from '../../../types/ChatWindow';
import { purifyAndLinkifyText } from '../messageHelper';

type IProps = { data: TextData };

const TextMessage: React.FC<IProps> = ({ data }) => {
  const { text } = data;
  const messageDisplay = purifyAndLinkifyText(text);
  const parsedText = parse(messageDisplay);

  return <div className='word-break-style'>{parsedText}</div>;
};

export default TextMessage;
